import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = () => {
  const theme = useTheme();
  const { currentLang, changeLanguage, supportedLanguages } = useLanguage();

  const handleLanguageChange = (lang) => {
    if (lang !== currentLang) {
      changeLanguage(lang);
    }
  };

  const languageLabels = {
    en: 'EN',
    de: 'DE',
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      {supportedLanguages.map((lang, index) => (
        <React.Fragment key={lang}>
          <Button
            onClick={() => handleLanguageChange(lang)}
            sx={{
              minWidth: '40px',
              padding: '4px 8px',
              color: currentLang === lang ? theme.palette.primary.main : '#fff',
              fontWeight: currentLang === lang ? 'bold' : 'normal',
              textTransform: 'uppercase',
              fontSize: '0.875rem',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            {languageLabels[lang] || lang.toUpperCase()}
          </Button>
          {index < supportedLanguages.length - 1 && (
            <Box
              sx={{
                color: '#fff',
                opacity: 0.5,
                userSelect: 'none',
              }}
            >
              |
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default LanguageSelector;
